import { Box, Card, Typography, useTheme } from "@mui/material";
import IMAGES from "lib/assets/images";
import { getDateFromISOString } from "lib/util/DateTimeUtil/getDateFromISOString/getDateFromISOString";
import ConfirmationCard from "ui/appointment/components/rescheduleAppointment/pages/confirmation/ConfirmationCard/ConfirmationCard";
import { sxStyles } from "./RescheduleConfirmationCard.styles";
import { RescheduleConfirmationCardProps } from "./RescheduleConfirmationCard.types";

const RescheduleConfirmationCard = ({
  institutionName,
  slotDetails,
}: RescheduleConfirmationCardProps) => {
  const theme = useTheme();
  const classes = sxStyles(theme);

  return (
    <Box
      data-testid={"cardRegion"}
      sx={classes.cardRegion}
      key={`${slotDetails.old.id}-${slotDetails.new?.id ?? "undefined"}`}
    >
      <Box sx={{ ...classes.layout, ...classes.cardSectionLayout }}>
        <Box sx={classes.cardLayout}>
          <Box sx={classes.cardHeaderContainer}>
            {institutionName && (
              <Typography sx={classes.institutionText}>
                {institutionName}
              </Typography>
            )}

            <Typography sx={classes.serviceDisplayName}>
              {slotDetails.old.serviceType}
            </Typography>
          </Box>

          <Card sx={classes.card}>
            {/* Booked Slot */}
            <Box sx={classes.cardtitle}>
              <Typography sx={classes.titleLeftText}>Current</Typography>
              <Box sx={{ opacity: 0.6 }}>
                <ConfirmationCard
                  slotDateTime={getDateFromISOString(
                    slotDetails.old.date || "",
                  )}
                />
              </Box>
            </Box>

            <Box
              component={"img"}
              src={IMAGES.general.ForwardIcon}
              sx={classes.arrow}
            />

            {/* Rescheduled Slot */}
            <Box sx={classes.cardtitle}>
              <Typography sx={classes.titleRightText}>New</Typography>
              <Card sx={classes.setNewCard}>
                <ConfirmationCard
                  slotDateTime={getDateFromISOString(
                    slotDetails.new?.date || "",
                  )}
                />
              </Card>
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default RescheduleConfirmationCard;
